export const createQueryString = (obj) => {
  const params = new URLSearchParams(obj);

  return `?${params.toString()}`;
};
